export default __webpack_public_path__ + "static/media/the-podcast-app.023bd5d5.png";